import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import "../assets/css/styles.table.css"
import Layout from './Layout';
import Box from '@mui/material/Box';
import DynamicDataGridComponent from '../components/DynamicDataGrid'
import GridNumberPaging from '../components/GridNumberPaging'
import Helper from './Helper';
import {usePOHook} from '../hook/POHook'
import Bindcomponent from '../utils/bindcomponent';

const PO = () => {
  const { id } = useParams();
  const Navigate = useNavigate();
  const {message,setmessage,errortipe,seterrortipe,AddProjectData,AddInvoice,columns,rows} = usePOHook(id)
  
  return (
    <>
    <Layout message={message} setmessage={setmessage} tipe={errortipe} settipe={seterrortipe}>
      <div className='pd'><b>WORK LIST</b></div>
      <div className="pd">
        <div style={{marginBottom:15, position:'relative', border:2}} >
        <div>
            <button className='btn btn-success' onClick={AddProjectData}>ADD ADDITIONAL WORK / PO</button>
        </div>
        <div style={{position:"absolute", right:0, top:0}} >
            <button className='btn btn-primary mr-2' onClick={()=> Navigate(`/RAK/${id}${Helper.SetReturnUrl()}`)} title="RAK">RAK</button>
            <button className='btn btn-info' onClick={AddInvoice} title="INVOICES">INVOICES</button>
        </div>
      </div>
    <Box sx={{ width: 1 }} >
      <Box sx={{ height: 550 }} >
           <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} name={"statusgrid"} rowid={"id"}></Bindcomponent>  
         {/* <GridNumberPaging customcolumns={columns} rows={rows} name={"statusgrid"} rowid={"id"}></GridNumberPaging> */}
      </Box>
    </Box>
    </div>
  </Layout>

    </>
  );
};

export default PO;